export class EnumCategoryShare {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "baseline",
            "baseName": "baseline",
            "type": "number",
            "format": "double"
        },
        {
            "name": "current",
            "baseName": "current",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return EnumCategoryShare.attributeTypeMap;
    }
    constructor() {
    }
}
